import moment from 'moment';
import { fetchUsers } from '../../../../api/users';

const validateEmail = async (rule?: any, newValue?: string): Promise<any> => {
  return fetchUsers(`&email=${newValue?.trim()}`).then(users => {
    if (newValue?.trim() && users.length > 0) {
      if (
        users.length &&
        (!users[0].enabled ||
          (users[0]?.['attributes']?.['account_end_date']?.[0]
            ? moment(
                parseInt(users[0]['attributes']['account_end_date'][0], 10),
              ).valueOf() < moment().valueOf()
            : false))
      ) {
        throw Error('User.colum.deactivateUser');
      } else {
        throw Error(`User.form.validation.isEmailValid`);
      }
    }
  });
};

export { validateEmail };
